var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayoutSize } from "@/hooks/layout";
import Header from "./header";
import PageLayout from "./pageLayout";
import Footer from "./footer";
import React, { useEffect } from "react";
import { useGetWidgetsPreferencesUserQuery } from "@/store/api";
import { useAppDispatch } from "@/hooks/store";
import { setWidgets } from "@/store/layoutSlice";
var applicationLayout = function ApplicationLayout() {
    var _this = this;
    var displaySize = useLayoutSize();
    var _a = useGetWidgetsPreferencesUserQuery(undefined), data = _a.data, error = _a.error, isLoading = _a.isLoading;
    var dispatch = useAppDispatch();
    useEffect(function () {
        var loadWidgets = function () { return __awaiter(_this, void 0, void 0, function () {
            var widgetsData, widgetsBySlot;
            var _a;
            return __generator(this, function (_b) {
                if (!data)
                    return [2 /*return*/];
                widgetsData = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.widgets;
                if (Array.isArray(widgetsData)) {
                    widgetsBySlot = widgetsData.reduce(function (acc, widget) {
                        var slot = widget.slot;
                        if (!acc[slot]) {
                            acc[slot] = [];
                        }
                        acc[slot].push(widget);
                        return acc;
                    }, {});
                    // Dispatch les widgets pour chaque slot
                    Object.entries(widgetsBySlot).forEach(function (_a) {
                        var slot = _a[0], widgets = _a[1];
                        dispatch(setWidgets({ slot: slot, widgets: widgets }));
                    });
                }
                return [2 /*return*/];
            });
        }); };
        loadWidgets();
    }, [data]);
    var classes = {
        "display-small": displaySize.displayIsSmall,
        "display-medium": displaySize.displayIsMedium,
        "display-large": displaySize.displayIsLarge,
        "display-below-small": displaySize.displayIsBelowSmall,
        "display-above-small": displaySize.displayIsAboveSmall,
        "display-below-medium": displaySize.displayIsBelowMedium,
        "display-above-medium": displaySize.displayIsAboveMedium,
        "display-below-large": displaySize.displayIsBelowLarge,
        "display-above-large": displaySize.displayIsAboveLarge,
    };
    var classNames = Object.entries(classes)
        .filter(function (cls) { return cls[1]; })
        .map(function (cls) { return cls[0]; })
        .join(" ");
    return (_jsxs("div", __assign({ className: "layout overflow-hidden flex flex-col w-full h-full page ".concat(classNames) }, { children: [_jsx(Header, {}), _jsx(PageLayout, {}), _jsx(Footer, {})] })));
};
export default React.memo(applicationLayout);
